import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id EAA6E06D-B798-4198-BF74-3B31F564A807
 * name information-symbol
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-symbol.svg
 * tags
 * - Settings 
 */
export const InformationSymbolIcon = createSvgIcon(<><path d="M11 9H13V7H11V9M11 17H13V11H11V17Z" /></>, 'InformationSymbolIcon');
export default InformationSymbolIcon